module.exports = __webpack_public_path__ + "static/media/loyalty-overlay.3ad0c5c7.svg";